export default __webpack_public_path__ + "static/media/title.91433b3c.jpg";